// Склонение текстов по полу. Одна реализация на фронт и на бэк: одну и ту же фразу
// («не показывалась N дней») собирают и мини-апп, и пуш бота — расходиться им нельзя.
//
// Зачем шаблон, а не две готовые строки: у подавляющего большинства фраз мужская и женская
// формы отличаются одной буквой, и держать их двумя копиями значит гарантированно однажды
// поправить только одну. Шаблон `не показывал{ся|ась}` держит фразу целиком в одном месте.
//
// Почему у «пол не указан» отдельная фраза, а не «показывал(ась)»: скобки и слеши — канцелярит,
// Луня так не говорит. Нейтральный вариант пишется вручную и обычно уходит в настоящее время
// («тебя не видно») — это читается как живая речь, а не как форма из госуслуг.
import type { Gender } from '../enums.js'

/** `{мужская|женская}` — обе части могут быть пустыми: `похож{|а}`. */
const ALTERNATIVE_RE = /\{([^{}|]*)\|([^{}|]*)\}/g

/**
 * Раскрывает альтернативы `{мужская|женская}` в шаблоне.
 *
 * @example inflectByGender('не показывал{ся|ась}', 'f') // 'не показывалась'
 * @example inflectByGender('ты похож{|а} на себя', 'm') // 'ты похож на себя'
 */
export function inflectByGender(template: string, gender: Gender): string {
  return template.replace(ALTERNATIVE_RE, (_match, masculine: string, feminine: string) =>
    gender === 'm' ? masculine : feminine,
  )
}

/**
 * Фраза по полу: пол известен — склоняем шаблон, не указан — берём отдельную формулировку.
 *
 * @example textByGender('f', '{Пропал|Пропала} на {n} дней', 'Тебя не видно {n} дней')
 */
export function textByGender(
  gender: Gender | null | undefined,
  template: string,
  neutral: string,
): string {
  return gender === 'f' || gender === 'm' ? inflectByGender(template, gender) : neutral
}
